var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Voice',{attrs:{"detail":{
  no: '05',
  belong: '花べっぷ',
  title: 'ホテルスタッフ',
  profile: '花べっぷ',
  name: '本田 まい',
  date: '２０１９年入社',
  sm: {
    belong: '花べっぷ',
    name: 'ホテルスタッフ',
  },
  intro: '笑顔を忘れずに、温泉宿ならではのお客さま一人ひとりに寄り添うサービスを。',
  content: [
    {
      title: '「人と深く関わりたい」思いから転職',
      text: 'JR九州グループの別会社から、ご縁がありホテル部門へ転職させていただきました。業界は異なりますが元々人と接するのが好きだったので、今の仕事はとても自分に向いていると思います。特に花べっぷは観光目的で来られる方がほとんどです。ビジネスホテルとは違ったアプローチで、スピードよりも、いかにお客さまに寄り添えるかという点が大事です。',
    },
    {
      title: 'スタッフ一丸となってサービス向上に励む',
      text: 'お客さまの立場になって、「何を求められているのか」を考えながら接客をするようにしています。私たちスタッフがお客さま一人ひとりにしっかりと向き合い、丁寧に接することで、またこのホテルへと足を運んでいただけるのではと思っています。職場はアットホームな雰囲気です。定期的に行われるサービス改善ミーティングでいろいろな意見を出し合い、皆で改善していこうという前向きな姿勢で日々業務に取り組んでいます。',
    },
    {
      title: '「グッドサービス賞」受賞で仕事に自信と誇り',
      text: 'ＪＲ九州ホテルズアンドリゾーツの社内表彰制度に「グッドサービス賞」というものがあり、私を含めたくさんの花べっぷスタッフが受賞しています。さらに私は、2023年4月からサービスマイスターとなり、業務にあたります。サービスマイスターとは、そのホテルのサービス全般を指導し改善を目指す、サービスに特化した責任者です。今後は、例えばレストランサービスをより良くするために、専門の方による講習会を設けるなど、必要なことをどんどん取り入れていきたいと考えています。',
    },
    {
      title: 'マネージャーとなり、花べっぷを支えたい',
      text: '今年はマネージャー試験を受ける予定です。キャリアアップを目指すのは、先輩方から受け継いだ花べっぷのおもてなし精神を絶やさず、進化させていくためです。今後転勤もあるかと思いますが、それまでは私の大好きな花べっぷを支えていければと考えています。これから増えていく後輩たちの模範になれるよう、頑張ります。',
    } ],
  career: [
    {
      year: '2019',
      text: '花べっぷにホテルスタッフとして配属',
      isLast: true,
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    } ],
  message: '「目と気と心を配り、感動を咲かせる」というサービス精神で日々業務に取り組んでいます。その中で、お客さまの「ありがとう」の声は励みになり、厳しい声は成長の糧になります。職場は明るく頼り甲斐のある上司や先輩ばかりですよ。皆さんにお会いできる日を楽しみにしています！',
  caption: true,
  navi: {
    prev: {
      title: '日本の丁寧なおもてなしを体験し接客業へ。海外のお客さまから「ありがとう」と言われるたび仕事の価値を実感',
      path: '04',
    },
    next: {
      title: 'サービススタッフから、本社勤務へ。ホテル現場とオフィスを円滑につなぎ、会社全体の成長に関わりたい',
      path: '06',
    },
  },
}}})}
var staticRenderFns = []

export { render, staticRenderFns }